module.exports = __webpack_public_path__ + "img/961-7f9fe8.png";